import {
    SignupState,
    SIGNUP_SET,
    SignupSetAction,
    SET_OFFICER_TITLES,
    SetOfficerTitles,
    SetFingerprintAction,
    SET_FINGERPRINT,
} from './types';

export const signSetAction = (
    signup: Partial<SignupState>,
): SignupSetAction => ({
    type: SIGNUP_SET,
    signup,
});

export const setOfficerTitles = (
    officerTitles: string[],
): SetOfficerTitles => ({
    type: SET_OFFICER_TITLES,
    data: officerTitles,
});

export const setFingerprint = (fingerprint: string): SetFingerprintAction => ({
    fingerprint,
    type: SET_FINGERPRINT,
});
